import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component:  () => import(/* webpackChunkName: "about" */ '../views/login/login.vue')
  },
  {
    path: '/login',
    name: 'login',
    component:  () => import(/* webpackChunkName: "about" */ '../views/login/login.vue')
  },
  // {
  //   path: '/DailyBI',
  //   name: 'DailyBI',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/DailyBI.vue')
  // },
  {
    path: '/owner_BI',
    name: 'owner_BI',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/DailyBI_owner.vue'),
    meta: { requiresAuth: true }
  },
  // {
  //   path: '/ADMIN_BI',
  //   name: 'ADMIN_BI',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/DailyBI_HZ.vue'),
  //   meta: { requiresAuth: false }
  // },
  // {
  //   path: '/SZ_OWNER_BI',
  //   name: 'SZ_OWNER_BI',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/DailyBI_SZ.vue'),
  //   meta: { requiresAuth: false }
  // },
  // {
  //   //深圳航威仓
  //   path: '/SZHW_BI',
  //   name: 'SZHW_BI',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/DailyBI_SZHW.vue')
  // },
  // {
  //   //深圳联威仓
  //   path: '/SZLW_BI',
  //   name: 'SZLW_BI',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/DailyBI_SZLW.vue')
  // },
  // {
  //   //深圳联威仓
  //   path: '/TESTPAGE',
  //   name: 'TESTPAGE',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../components/testPage.vue')
  // },
]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 判断是否需要鉴权
    const token = localStorage.getItem('token') // 假设token保存在localStorage中
    if (!token) {
      // 如果token不存在，重定向到登录页面或其他处理方式
      next('/login') // 重定向到首页
    } else {
      next() // 继续导航
    }
  } else {
    next() // 不需要鉴权的路由直接导航
  }
})
export default router
